import { colors } from "@material-ui/core";
import React from "react";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

const PixelIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["pixelId"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const PixelIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "pixelId" in settings;

  return (
    <DestinationConfigRow
      name="Pixel ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OtherModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["initWithExistingTraits", "userIdAsExternalId"]}
      open={open}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const OtherRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const enabled = !!settings.pixelId;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Other settings"
      labelText=""
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const PIXEL_ID = "PIXEL_ID";
const OTHER = "OTHER";

const Rows = {
  [PIXEL_ID]: PixelIDRow,
  [OTHER]: OtherRow,
};

const Modals = {
  [PIXEL_ID]: PixelIDModal,
  [OTHER]: OtherModal,
};

const RowOrder = [PIXEL_ID, OTHER];

export default {
  Rows,
  RowOrder,
  Modals,
};
